import {
  GET_TASTING_HEADERS_REQUEST,
  GET_TASTING_HEADERS_SUCCESS,
  GET_TASTING_HEADERS_FAILURE,
  GET_TASTING_DATA_BY_HEADER_REQUEST,
  GET_TASTING_DATA_BY_HEADER_SUCCESS,
  GET_TASTING_DATA_BY_HEADER_FAILURE,
  UPDATE_ANSWER_REQUEST,
  RESET_TASTING_HEADERS,
  TOGGLE_TEXTUAL_INTENSITY_OPTION,
  SUBMIT_TASTING_DATA_BY_HEADER_FAILURE,
  SUBMIT_TASTING_DATA_BY_HEADER_SUCCESS,
  SUBMIT_TASTING_DATA_BY_HEADER_REQUEST,
  START_REVIEW_SUCCESS,
  UPDATE_LOG_REQUEST,
  RESET_LOG_REQUEST,
  UPDATE_SURVEY_LOG_REQUEST,
  GET_TASTING_DATA_BY_QUESTION_SUCCESS,
  GET_TASTING_DATA_BY_QUESTION_REQUEST,
  SUBMIT_TASTING_DATA_BY_QUESTION_REQUEST,
  SUBMIT_TASTING_DATA_BY_QUESTION_SUCCESS,
  SUBMIT_TASTING_DATA_BY_QUESTION_FAILURE
} from "../../actions/tasting/constants";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import { OPTION_CLEARED, OPTION_DESELECTED, OPTION_SELECTED } from "../../utils/tastingHelper";
import { IMPORTANT_SATISFACTION_QUESTION_TYPE, MEDIA_QUESTION_TYPE, MULTI_SELECT_CHECK_QUESTION_TYPE, MULTI_SELECT_RADIO_QUESTION_TYPE, RANK_QUESTION_TYPE } from "../../utils/surveyHelper";

const INITIAL_STATE = {
  headers: [],
  fetching: false,
  error: false,
  currentHeader: null,
  currentHeaderData: {
    data: null,
    fetching: false,
    error: false,
  },
  currentInfo: {},
  currentAnswers: null,
  currentLogs: {},
  currentSelectedOption: null,
  currentSelectedTextualIntensityOption: null,
  submitFailure: false,
  submitError: null,
  data: null,
  isStartAlready: false
};

const trasformDataForMinSelectionForNestedQuestion = (data) => {
  const newData = {
    ...data,
    question: data.question.map((_) => {
      if (
        !!_.is_nested_option &&
        _.nested_option_type &&
        _.nested_option_type === 2
      ) {
        const sequenceIdForDefaultOptionType = _.option
          .filter((option) => option.option_type === 0 && option.sequence_id)
          .map((option) => option.sequence_id),
          availableMinAromaOnlySequenceId =
            _.min_aroma_selection && _.min_aroma_selection.length
              ? _.min_aroma_selection.map((minAroma) => minAroma.sequence_id)
              : [],
          minAromaSelectionWithoutAlreadyAvailale =
            sequenceIdForDefaultOptionType
              .filter((_) => !availableMinAromaOnlySequenceId.includes(_))
              .map((_) => {
                return {
                  sequence_id: _,
                  min_selection: 1,
                };
              });
        return {
          ..._,
          min_aroma_selection:
            _.min_aroma_selection && _.min_aroma_selection.length
              ? [
                ..._.min_aroma_selection,
                ...minAromaSelectionWithoutAlreadyAvailale,
              ]
              : [...minAromaSelectionWithoutAlreadyAvailale],
        };
      }
      return _;
    }),
  };
  return newData;
};

const trasformDataForMinSelectionForNestedQuestionForSingleView = (question) => {
  if (!question) return false;
  const questionWithData = {
    question: [question]
  }
  const transformedData = trasformDataForMinSelectionForNestedQuestion(questionWithData);
  return transformedData.question[0];
};

// function for addding timestamp in entry for interactions
const addInteraction = (interactions, type, time, columnId, rank) => {
  return [...interactions, {
    ...(columnId && { column_id: columnId }),
    ...(rank && { rank: rank }),
    "event": type,
    "timestamp": time
  }];
};

// Helper to create a new response_activity entry
const createResponseEntry = (questionId, optionId, isMediaQuestion, helperData, columnId, rank, eventType, currentTime) => {
  const entry = {
    question_id: questionId,
    interactions: [
      {
        event: eventType,
        timestamp: currentTime
      }
    ]
  };

  if (optionId) entry.option_id = optionId;
  if (isMediaQuestion) entry.media_type = helperData.mediaType;
  if (columnId) entry.interactions[0].column_id = columnId;
  if (rank) entry.interactions[0].rank = rank;

  return entry;
};


// get option id based on question type
const getOptionKey = (currentQuestion) => {
  let targetKey = "id";

  if ((Number(currentQuestion.question_type) === RANK_QUESTION_TYPE || Number(currentQuestion.question_type) === MULTI_SELECT_RADIO_QUESTION_TYPE)) {
    targetKey = "value";
  }
  return targetKey;
}

// function for clearing out response activity for currentquestions after submitting the answer 
function filterSectionWiseLogs(currentLogs, questionsIds) {
  const result = {};

  for (const key in currentLogs) {
    if (currentLogs.hasOwnProperty(key)) {
      const qid = Number(key);
      const item = currentLogs[key];

      // Convert sectionIds to number comparison
      const isInSection = questionsIds.indexOf(qid) !== -1;
      
      if (isInSection) {
        // Only keep first_interacted_at and last_interacted_at
        result[qid] = {};
      } else {
        // Keep full data as it is
        result[qid] = { ...item };
      }
    }
  }

  return result;
}

const getMediaActivity = (answer, currentTime, searchKey, targetKey, updatedInteraction, questionId) => {
  const answerInteractions = answer[searchKey].map((image) => {
    return {
      "event": OPTION_DESELECTED,
      "timestamp": currentTime
    }
  });


  let isExistingResponseActivity = null;
  if (updatedInteraction.response_activity && updatedInteraction.response_activity.length) {
    isExistingResponseActivity = updatedInteraction.response_activity.find((item) => item.media_type === targetKey);
  }


  const finalUpdatedActivity = {
    media_type: targetKey,
    question_id: questionId,
    interactions: [...(isExistingResponseActivity ? isExistingResponseActivity.interactions : []), ...answerInteractions]
  }

  return finalUpdatedActivity;
}


const getMediaFinalActivity = (questionWiseAnswer, currentTime, updatedInteraction, questionId) => {
  let mediaActivity = [];
  questionWiseAnswer.map(anwser => {

    if (anwser.image_meta && anwser.image_meta.length >= 1) {
      mediaActivity = [...mediaActivity, getMediaActivity(
        anwser, currentTime, "image_meta", "image", updatedInteraction, questionId)]
    }
    if (anwser.document_meta && anwser.document_meta.length >= 1) {
      mediaActivity = [...mediaActivity, getMediaActivity(
        anwser, currentTime, "document_meta", "document", updatedInteraction, questionId)]
    }
    if (anwser.media_url && anwser.media_url.length >= 1) {
      mediaActivity = [...mediaActivity, getMediaActivity(
        anwser, currentTime, "media_url", "media_url", updatedInteraction, questionId)]
    }
  })

  return mediaActivity
}

const getQuestionActivityFromAnswer = (questionWiseAnswer, currentQuestion, updatedInteraction, currentTime, questionId) => {
  let answerWiseActivity = questionWiseAnswer.map((answer) => {
    // getting option_id key from  current question , we store option id in different keys for different questions
    const optionId = Number(currentQuestion.question_type) === IMPORTANT_SATISFACTION_QUESTION_TYPE ? answer["value"]["id"] : answer[getOptionKey(currentQuestion)];
    const columnId = Number(currentQuestion.question_type) === MULTI_SELECT_RADIO_QUESTION_TYPE && answer["id"];
    const rank = Number(currentQuestion.question_type) === RANK_QUESTION_TYPE && answer["id"];

    // if we have response activity for same option , so we have to add deselected event with exiting interactions
    let isExistingResponseActivity = null;
    if (updatedInteraction.response_activity && updatedInteraction.response_activity.length) {
      isExistingResponseActivity = updatedInteraction.response_activity.find((item) => Number(item.option_id) === Number(optionId));
    }
    return {
      ...{ question_id: questionId },
      ...(optionId && { option_id: optionId }),

      interactions: addInteraction(
        (isExistingResponseActivity ? isExistingResponseActivity.interactions : []),
        OPTION_DESELECTED,
        currentTime,
        columnId,
        rank,
      )
    }
  });
  return answerWiseActivity || [];
}

const getMultiGridFinalActivity = (questionWiseAnswer, currentTime, updatedInteraction, questionId) => {
  const groupedMap = {};

  questionWiseAnswer.forEach((item) => {
    const optionId = item.id;
    const value = item.value;

    // If this option id does not exist, initialize it
    if (!groupedMap[optionId]) {
      groupedMap[optionId] = {
        id: optionId,
        value: []
      };
    }

    // Push value into values array
    if (typeof value === "string") {
      groupedMap[optionId].value.push(value);
    } else if (Array.isArray(value)) {
      groupedMap[optionId].value.push(...value);
    }
  });
  let answers = Object.values(groupedMap);

  let answerWiseActivity = answers.map((answer) => {
    // getting option_id key from  current question , we store option id in different keys for different questions
    const optionId = answer["id"];

    // if we have response activity for same option , so we have to add deselected event with exiting interactions
    let isExistingResponseActivity = null;
    if (updatedInteraction.response_activity && updatedInteraction.response_activity.length) {
      isExistingResponseActivity = updatedInteraction.response_activity.find((item) => Number(item.option_id) === Number(optionId));
    }
    let answerInteractions = [];
    if (answer.value && answer.value.length) {
      answerInteractions = answer["value"].filter(item => !!item).map((item) => {
        return {
          "event": OPTION_DESELECTED,
          "timestamp": currentTime,
          "column_id": Number(item)
        }
      });
    }

    return {
      ...{ question_id: questionId },
      ...(optionId && { option_id: optionId }),
      interactions: [
        ...(isExistingResponseActivity ? isExistingResponseActivity.interactions : []),
        ...answerInteractions
      ]
    }
  });

  return answerWiseActivity || [];
}

const mergeWithExistingResponseActivity = (
  newActivities,
  existingActivities,
  matchFn
) => {
  let remainingActivities = newActivities;

  if (existingActivities && existingActivities.length) {
    const merged = existingActivities.map((item) => {
      const index = remainingActivities.findIndex((a) => matchFn(a, item));

      if (index !== -1) {
        const matchedItem = remainingActivities[index];
        remainingActivities = remainingActivities.toSpliced(index, 1);
        return matchedItem;
      }
      return item;
    });

    return [...merged, ...remainingActivities];
  }

  // When no existing response activity
  return [...newActivities];
};

const getFinalActivity = (
  questionWiseAnswer,
  currentQuestion,
  currentTime,
  updatedInteraction,
  questionId,
  actionType
) => {
  const isSurveyActionType = actionType === UPDATE_SURVEY_LOG_REQUEST;  
  const isMediaQuestion = isSurveyActionType && Number(currentQuestion.question_type) === MEDIA_QUESTION_TYPE;
  const isMultiGridQuestion = isSurveyActionType && Number(currentQuestion.question_type) === MULTI_SELECT_CHECK_QUESTION_TYPE;
  if (isMediaQuestion) {
    const newActivities = getMediaFinalActivity(
      questionWiseAnswer,
      currentTime,
      updatedInteraction,
      questionId
    );

    return mergeWithExistingResponseActivity(
      newActivities,
      updatedInteraction.response_activity,
      (a, b) => a.media_type === b.media_type
    );
  } else if (isMultiGridQuestion) {
    const newActivities = getMultiGridFinalActivity(
      questionWiseAnswer,
      currentTime,
      updatedInteraction,
      questionId
    );

    return mergeWithExistingResponseActivity(
      newActivities,
      updatedInteraction.response_activity,
      (a, b) => Number(a.option_id) === Number(b.option_id)
    );
  } else {
    const newActivities = getQuestionActivityFromAnswer(
      questionWiseAnswer,
      currentQuestion,
      updatedInteraction,
      currentTime,
      questionId
    );

    return mergeWithExistingResponseActivity(
      newActivities,
      updatedInteraction.response_activity,
      (a, b) => Number(a.option_id) === Number(b.option_id)
    );
  }
}

export default function tasting(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_TASTING_HEADERS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case GET_TASTING_HEADERS_SUCCESS:
      return {
        ...state,
        headers: [...action.payload],
      };
    case GET_TASTING_HEADERS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    case START_REVIEW_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isStartAlready: true
      };
    case GET_TASTING_DATA_BY_HEADER_REQUEST:
      return {
        ...state,
        currentHeaderData: {
          ...state.currentHeaderData,
          fetching: true,
        },
      };
    case GET_TASTING_DATA_BY_QUESTION_REQUEST:
      return {
        ...state,
        currentInfo: {
          ...state.currentInfo,
          fetching: true
        }
      };
    case GET_TASTING_DATA_BY_HEADER_SUCCESS:
    case GET_TASTING_DATA_BY_QUESTION_SUCCESS:
      let answerObj = {};

      const rawAnswers =
        action.payload.answers ||
        action.payload.answer ||
        [];

      const answers = Array.isArray(rawAnswers) // single & multi view handling 
        ? rawAnswers
        : [rawAnswers];

      answers.forEach((_) => {
        if (_.comment) {
          answerObj[`${_.question_id}`] = {
            comment: _.comment,
            ...(_.select_type && { select_type: _.select_type }),
          };
        } else if (_.option && _.option.length) {
          answerObj[`${_.question_id}`] = {
            option: _.option,
            ...(_.select_type && { select_type: _.select_type }),
          };
        } else if (typeof _.meta === "object" && _.meta !== null) {
          answerObj[`${_.question_id}`] = {
            meta: _.meta,
            ...(_.select_type && { select_type: _.select_type }),
            ...(_.track_consistency && {
              track_consistency: _.track_consistency,
            }),
          };
        } else if (_.files && !isEmpty(_.files)) {
          answerObj[`${_.question_id}`] = {
            files: _.files,
            ...(_.select_type && { select_type: _.select_type }),
          };
        }
      });
      const questionTransformedData =
        action.payload &&
          action.payload.question &&
          action.payload.question.length
          ? trasformDataForMinSelectionForNestedQuestion(action.payload)
          : action.payload;
      const isQuestionLevel =
        action.type === GET_TASTING_DATA_BY_QUESTION_SUCCESS;
      return {
        ...state,
        ...(isQuestionLevel
          ? {
            currentInfo: {
              ...state.currentInfo,
              currentHeader: action.payload.header || {},
              currentQuestionIndex: Number(action.payload.question_index),
              totalQuestionCount: action.payload.questions_count != null
                ? Number(action.payload.questions_count)
                : state.currentInfo.totalQuestionCount,
              currentQuestion: trasformDataForMinSelectionForNestedQuestionForSingleView(action.payload.question) || {}
            },
          }
          : {
            currentHeaderData: {
              fetching: false,
              data: questionTransformedData,
            },
            currentHeader: state.headers.find(
              (header) => header.id === action.payload.currentheaderId
            ),
          }),

        currentAnswers: (answers.length > 0) ? answerObj : null,
        currentLogs: answers.reduce((acc, question) => {
          const log = {
            first_interacted_at: question.first_interacted_at,
            last_interacted_at: question.last_interacted_at
          };

          if (question.selected_at) {
            log.selected_at = question.selected_at;
          } else {
            const selectedOptions = {};
            get(question, 'option', []).forEach(option => {
              if (option.selected_at != null) {
                selectedOptions[option.id] = option.selected_at;
              }
            });

            if (Object.keys(selectedOptions).length > 0) {
              log.option_selected_at = selectedOptions;
            }
          }
          acc[question.question_id] = log;
          return acc;
        }, {})
      };
    case GET_TASTING_DATA_BY_HEADER_FAILURE:
      return {
        ...state,
        currentHeaderData: {
          error: action.error,
        },
      };
    case UPDATE_ANSWER_REQUEST:
      return {
        ...state,
        currentAnswers: {
          ...state.currentAnswers,
          [`${action.payload.questionId}`]: {
            [`${action.payload.key}`]: action.payload.newAnswer,
            ...(action.payload.selectType &&
              action.payload.isPublicCollab && {
              select_type: action.payload.selectType,
            }),
            ...(action.payload.trackConsistency && {
              track_consistency: action.payload.trackConsistency,
            }),
          },
        },
      };
    
    case UPDATE_LOG_REQUEST:
    case UPDATE_SURVEY_LOG_REQUEST: {
      const questionId = action.payload.questionId;
      const optionId = action.payload.optionId;
      const type = action.payload.type || "";
      const isOptionBased = optionId !== undefined && optionId !== null; // flag for determining option
      const isSubmit = action.payload.isSubmit; // flag used for selected_at key
      const currentTime = Math.floor(Date.now() / 1000); // converting to seconds
      const helperData = action.payload.utilityData; // const used for any utility data if required 
      const isMediaQuestion = helperData && helperData.mediaType;  // used for handling media type 
      const columnId = helperData && helperData.column; // used for sending columnId in multi selected radio and checkbox
      const rank = helperData && helperData.rank; // // used for sending rank in rank question
      const singleInteraction = helperData && helperData.index; // used for handling index for comments , selfie and overall preference.
      const questionWiseAnswer = helperData && helperData.answers; // used for handling answers question wise for clear section in survey.
      const currentQuestion = helperData && helperData.question; // used for taking helper or needed data so that logic can we implemeted.

      const existingLog = state.currentLogs[questionId] || {};
      const existingOptionLog = existingLog.option_selected_at || {};

      // common log for all question types
      const updatedInteraction = {
        ...existingLog,
        first_interacted_at: existingLog.first_interacted_at || currentTime,
        last_interacted_at: currentTime
      };

      // MAIN LOGIC , when we click on clear selection
      if (type === OPTION_CLEARED ) {
        // firstly making response activity from answers 
        updatedInteraction.response_activity = getFinalActivity(questionWiseAnswer, currentQuestion,currentTime, updatedInteraction, questionId , action.type)
      }

      // type can be three types : selected , deselected and cleared for survey.
      if (type === OPTION_SELECTED || type === OPTION_DESELECTED) {
        const eventType = action.payload.type;

        // If no response_activity exists, create the first entry
        if (!updatedInteraction.response_activity || updatedInteraction.response_activity.length === 0) {
          updatedInteraction.response_activity = [
            createResponseEntry(
              questionId,
              optionId,
              isMediaQuestion,
              helperData,
              columnId,
              rank,
              eventType,
              currentTime,
            )
          ];
        } else {
          let index = -1;
          const resp = updatedInteraction.response_activity;

          if (optionId) {
            index = resp.findIndex((o) => Number(o.option_id) === Number(optionId));
          } else if (isMediaQuestion) {
            index = resp.findIndex((o) => o.media_type === helperData.mediaType);
          } else if (singleInteraction === "single") {
            index = 0;
          }

          // Updating existing entry
          if (index !== -1) {
            const item = resp[index];
            resp[index] = {
              ...item,
              interactions: addInteraction(
                item.interactions,
                eventType,
                currentTime,
                columnId,
                rank,
              )
            };
          } else {
            // Create new entry
            resp.push(
              createResponseEntry(
                questionId,
                optionId,
                isMediaQuestion,
                helperData,
                columnId,
                rank,
                eventType,
                currentTime,
              )
            );
          }
        }
      }

      //submit case - selected_at will be appended  
      if (isSubmit) {
        if (isOptionBased) { //option level if option
          updatedInteraction.option_selected_at = {
            ...existingOptionLog,
            [optionId]: currentTime
          };
        } else { // question level if no option 
          if (action.type === UPDATE_LOG_REQUEST) {
            updatedInteraction.selected_at = currentTime;
          }
        }
      }

      return {
        ...state,
        currentLogs: {
          ...state.currentLogs,
          [questionId]: updatedInteraction
        }
      };
    }


    case TOGGLE_TEXTUAL_INTENSITY_OPTION:
      return {
        ...state,
        currentSelectedTextualIntensityOption: action.payload,
      };
    case SUBMIT_TASTING_DATA_BY_HEADER_FAILURE:
    case SUBMIT_TASTING_DATA_BY_QUESTION_FAILURE:
      return {
        ...state,
        submitFailure: true,
        submitError: action.error,
      };
    case SUBMIT_TASTING_DATA_BY_HEADER_SUCCESS:
    case SUBMIT_TASTING_DATA_BY_HEADER_REQUEST:
    case SUBMIT_TASTING_DATA_BY_QUESTION_REQUEST:
    case SUBMIT_TASTING_DATA_BY_QUESTION_SUCCESS:
      return {
        ...state,
        submitFailure: false,
        submitError: null,
      };
    case RESET_TASTING_HEADERS:
      return INITIAL_STATE;
    case RESET_LOG_REQUEST:
      return {
        ...state,
        currentLogs: filterSectionWiseLogs(state.currentLogs, action.payload.questions_ids)
      }
    default:
      return state;
  }
}
